import { defineStore } from "pinia";
import type {
  NavigationGuardWithThis,
  RouteLocationRaw,
} from "vue-router";

export type LocationStore = {
  PREV_LOCATION?: RouteLocationRaw;
  ROUTER_BEFORE_EACH: NavigationGuardWithThis<void>[];
};

export const useLocationStore = defineStore({
  id: "locationStore",
  state: (): LocationStore => ({
    PREV_LOCATION: undefined,
    // ROUTER_BEFORE_EACH viene controllato in src/router/index.ts.
    // Se contiene funzioni vengono eseguite all'interno della funzione router.beforeEach
    // utile per configurare hook onshot. per esempio popup/modal che impediscono il cambio della pagina
    ROUTER_BEFORE_EACH: [],
  }),
  getters: {
    PREV_LOCATION_get: (state) => state.PREV_LOCATION,
    ROUTER_BEFORE_EACH_get: (state) => state.ROUTER_BEFORE_EACH,
  },
  actions: {
    PREV_LOCATION_set(value?: RouteLocationRaw) {
      this.PREV_LOCATION = value;
    },
    ROUTER_BEFORE_EACH_set(callback: NavigationGuardWithThis<void>) {
      this.ROUTER_BEFORE_EACH.push(callback);
    },
    ROUTER_BEFORE_EACH_unset(callback: NavigationGuardWithThis<void>) {
      const id = this.ROUTER_BEFORE_EACH.indexOf(callback);
      if (id == -1) return;
      this.ROUTER_BEFORE_EACH.splice(id, 1);
    },
    async back(def?: RouteLocationRaw) {
      if (this.PREV_LOCATION) {
        await this.$router.replace(this.PREV_LOCATION);
      } else if (def) {
        await this.$router.replace(def);
      }
    },
    async toHome() {
      await this.$router.push({ name: "Home" });
    },
  },
});
